import { DatePicker } from "antd";
import moment, { Moment, isMoment } from "moment";
import { useEffect, useRef } from "react";
import { calculateDayjsValue, getFormat } from "./angularDatePickerModel";

export type Props = {
  date: string | null | Moment,
  onChange: (value: string | undefined | Moment) => void
  mode: 'date' | 'time' | 'datetime',
  format?: string,
  displayFormat?: string,
  disabled?: boolean,
  width?: string,
  containerId?: string
}

const AngularDatePicker = (props: Props) => {
  const { date, onChange, mode, disabled, width, containerId } = props
  const format = getFormat(mode, props.format)
  const displayFormat = props.displayFormat ?? format
  const useMoment = isMoment(date)
  const containerRef = useRef<any>()

  useEffect(() => {
    if (containerId) {
      containerRef.current = document.getElementById(containerId)
    }
  }, [containerId])

  const dayjsValue = calculateDayjsValue(date, format)

  const datePicker = <DatePicker
    value={dayjsValue}
    picker={mode === 'time' ? 'time' : 'date'}
    format={displayFormat}
    showTime={mode === 'datetime'}
    disabled={disabled}
    onChange={v => {
      const formatted = v?.format(format);
      onChange(useMoment && formatted ? moment(formatted) : formatted);
    }}
    getPopupContainer={() => containerRef.current}
    style={{
      borderRadius: 0,
      height: 46,
      alignItems: 'center',
      padding: '6px 12px',
      fontSize: '1rem',
      lineHeight: '34px',
      color: '#555',
      backgroundColor: 'white',
      borderWidth: 1,
      borderColor: '#ccc',
      boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075)',
      width
    }} />;

  if (containerId) {
    return datePicker
  }

  return <div ref={containerRef}>
    {datePicker}
  </div>
}

export default AngularDatePicker
